(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('dattelmond-header')) {
  customElements.define('dattelmond-header', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.header = this.querySelector('.dm-header');
      this.dialog = this.querySelector('.dm-drawer');
      this.toggleButton = this.querySelector('.dm-drawer-toggle');
      this.desktop = this.querySelector('.dm-nav--desktop');
      this.hoverTimers = new Map();
      if (!this.header) return;

      this.toggleButton?.addEventListener('click', () => this.openDrawer(), options);
      this.querySelector('.dm-close')?.addEventListener('click', () => this.closeDrawer(), options);
      this.dialog?.addEventListener('close', () => this.restoreAfterDrawer(), options);
      this.dialog?.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDrawer();
      }, options);

      this.querySelectorAll('.dm-top-item').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          const nav = detail.closest('.dm-nav');
          if (nav === this.desktop || this.dataset.mobileExclusive === 'true') {
            nav.querySelectorAll('.dm-top-item[open]').forEach((other) => {
              if (other !== detail) other.open = false;
            });
          }
        }, options);
        detail.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && detail.open) {
            event.preventDefault();
            event.stopPropagation();
            detail.open = false;
            detail.querySelector('summary').focus();
          }
          if (event.key === 'ArrowDown' && event.target === detail.querySelector('summary') && detail.closest('.dm-nav') === this.desktop) {
            event.preventDefault();
            detail.open = true;
            detail.querySelector('.dm-submenu a')?.focus();
          }
        }, options);
        if (detail.closest('.dm-nav') === this.desktop && this.dataset.desktopOpen === 'hover') {
          detail.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            clearTimeout(this.hoverTimers.get(detail));
            this.hoverTimers.set(detail, setTimeout(() => { detail.open = true; }, 150));
          }, options);
          detail.addEventListener('pointerleave', () => {
            clearTimeout(this.hoverTimers.get(detail));
            if (detail.contains(document.activeElement)) return;
            this.hoverTimers.set(detail, setTimeout(() => { detail.open = false; }, 200));
          }, options);
        }
      });

      document.addEventListener('click', (event) => {
        if (!event.target.closest('.dm-nav--desktop') || !this.contains(event.target)) this.closeDesktop();
      }, options);
      document.addEventListener('focusin', (event) => {
        if (!this.desktop?.contains(event.target)) this.closeDesktop();
      }, options);
      window.addEventListener('pagehide', () => {
        this.closeDesktop();
        this.closeDrawer();
      }, options);
      window.addEventListener('hashchange', () => {
        this.closeDesktop();
        this.closeDrawer();
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const mode = this.dataset.layout === 'desktop' ? 'desktop' : 'mobile';
        const selector = `.dm-nav--${mode} [data-dm-block="${CSS.escape(event.detail.blockId)}"]`;
        const target = this.querySelector(selector);
        if (!target) return;
        if (mode === 'mobile') this.openDrawer();
        const detail = target.closest('.dm-top-item') || target.querySelector('.dm-top-item');
        if (detail) detail.open = true;
      }, options);

      this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
      this.resizeObserver.observe(this.header);
      const icons = this.header.querySelector('.header__icons');
      if (icons) this.resizeObserver.observe(icons);
      window.addEventListener('resize', () => this.scheduleMeasure(), options);
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.scheduleMeasure(); });
      this.header.querySelectorAll('img').forEach((img) => img.addEventListener('load', () => this.scheduleMeasure(), options));
      this.measure();
    }

    scheduleMeasure() {
      cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => this.measure());
    }

    measure() {
      if (!this.isConnected || !this.desktop) return;
      const viewport = document.documentElement.clientWidth;
      const minimum = Number(this.dataset.breakpoint) || 990;
      let mode = 'mobile';
      if (this.dataset.forceDrawer !== 'true' && viewport >= minimum) {
        this.setAttribute('data-measuring', '');
        const menuWidth = this.desktop.querySelector('.dm-menu-root').getBoundingClientRect().width;
        const iconsWidth = this.header.querySelector('.header__icons')?.getBoundingClientRect().width || 0;
        const logoWidth = Number(this.dataset.logoWidth) || 180;
        const gap = Number(this.dataset.headerGap) || 24;
        const width = this.header.getBoundingClientRect().width;
        this.removeAttribute('data-measuring');
        if (menuWidth + iconsWidth + logoWidth + gap * 2 + 56 + 20 <= width) mode = 'desktop';
      }
      if (mode !== this.dataset.layout) {
        this.closeDesktop();
        if (mode === 'desktop') this.closeDrawer();
        this.dataset.layout = mode;
      }
      document.documentElement.style.setProperty('--header-height', `${this.header.closest('.section-header')?.offsetHeight || this.header.offsetHeight}px`);
    }

    closeDesktop() {
      this.hoverTimers?.forEach((timer) => clearTimeout(timer));
      this.desktop?.querySelectorAll('.dm-top-item[open]').forEach((detail) => { detail.open = false; });
    }

    openDrawer() {
      if (!this.dialog || this.dialog.open) return;
      this.closeDesktop();
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.toggleButton?.setAttribute('aria-expanded', 'true');
      this.querySelector('.dm-close')?.focus();
    }

    closeDrawer() {
      if (!this.dialog?.open) return;
      this.dialog.close();
      this.restoreAfterDrawer();
    }

    restoreAfterDrawer() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      if (this.previousFocus?.isConnected && this.previousFocus.getClientRects().length) this.previousFocus.focus();
      this.previousFocus = undefined;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.measureFrame);
      this.closeDrawer();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.hoverTimers?.forEach((timer) => clearTimeout(timer));
      this.controller = undefined;
    }
  });
}


if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.getAttribute('data-sticky-type') === 'none') return;
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mediaQuery?.removeEventListener('change', this.onMediaChange);
      clearTimeout(this.isScrolling);
      this.intersectionObserver?.disconnect();
    }

    createObserver() {
      this.intersectionObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.intersectionObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.closest('dattelmond-header')?.querySelector('dialog[open], .dm-nav--desktop .dm-top-item[open]')) {
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.closest('dattelmond-header')?.closeDesktop?.();
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

}


  } catch(e) { console.error(e); }
})();
})();
